import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LocationCards = () => (
  <section className="section" style={{ background: "var(--lrg-surface)" }} data-testid="location-cards-section">
    <div className="container-custom">
      <div className="max-w-md mb-20">
        <p className="overline mb-5">Locations</p>
        <h2 className="font-editorial text-4xl sm:text-5xl font-medium text-[#F2EDE4] leading-[1.1]">
          One academy.<br />Two homes.
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        <Link to="/baltimore" className="group block" data-testid="loc-card-baltimore">
          <div className="lrg-card h-full py-12 px-10">
            <p className="overline mb-8">Baltimore, Maryland</p>
            <h3 className="font-editorial text-3xl font-medium text-[#F2EDE4] mb-4 group-hover:text-[#0D6B56] transition-colors duration-500">Baltimore</h3>
            <p className="text-xs text-[#6B6E71] leading-[1.9] mb-8">
              Coppermine Bare Hills & DS Timonium. Junior academy, adult clinics, private coaching, and unlimited membership.
            </p>
            <span className="text-[10px] font-medium text-[#3A3D40] group-hover:text-[#0D6B56] transition-colors duration-500 inline-flex items-center gap-2 uppercase tracking-[0.15em]">
              Explore <ArrowRight className="w-3 h-3" />
            </span>
          </div>
        </Link>

        <Link to="/princeton" className="group block" data-testid="loc-card-princeton">
          <div className="lrg-card h-full py-12 px-10">
            <p className="overline mb-8">Princeton, New Jersey</p>
            <h3 className="font-editorial text-3xl font-medium text-[#F2EDE4] mb-4 group-hover:text-[#0D6B56] transition-colors duration-500">Princeton</h3>
            <p className="text-xs text-[#6B6E71] leading-[1.9] mb-8">
              NJSC — 11 Princess Road. Movement clinics, match play, strength training, private lessons, and 24/7 member access.
            </p>
            <span className="text-[10px] font-medium text-[#3A3D40] group-hover:text-[#0D6B56] transition-colors duration-500 inline-flex items-center gap-2 uppercase tracking-[0.15em]">
              Explore <ArrowRight className="w-3 h-3" />
            </span>
          </div>
        </Link>
      </div>
    </div>
  </section>
);

export default LocationCards;
